import constants from 'constants'

const {
    GET_SUPERHOST,
    GET_SUPERHOSTS,
    SAVE_SUPERHOSTS,
    CREATE_SUPERHOST,
    UPDATE_SUPERHOST,
    DELETE_SUPERHOSTS,
	SET_SUPERHOST
} = constants

export const getSuperhost = (id) => ({
    type: GET_SUPERHOST,
    id,
});

export const getSuperhosts = (query, page = 1) => ({
    type: GET_SUPERHOSTS,
    query,
    page
})

export const setSuperhost = (superhost) => ({
	type: SET_SUPERHOST,
	superhost
})

export const saveSuperhosts = (payload) => ({
    type: SAVE_SUPERHOSTS,
    payload
})

export const createSuperhost = (superhost) => ({
    type: CREATE_SUPERHOST,
    superhost
})

export const updateSuperhost = (id, superhost) => ({
    type: UPDATE_SUPERHOST,
    id,
    superhost
})

export const deleteSuperhosts = (superhost_ids) => ({
    type: DELETE_SUPERHOSTS,
    superhost_ids
})


// WEBPACK FOOTER //
// ./src/actions/superhosts.js